var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.which_to_show)?_c('div',[_c(_vm.which_to_show,{tag:"component"})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }